var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeactivateBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16V10H0V8L1 3H16L17 8V10H16V13H14V10H10V16H1ZM3 14H8V10H3V14ZM1 2V0H16V2H1ZM2.05 8H14.95L14.35 5H2.65L2.05 8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17H12V15H15H17H20V17H17H15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeactivateBusiness);
export default __webpack_public_path__ + "static/media/icon_deactivate_business.83a3752622d8ce101ed6de3feb61d5f5.svg";
export { ForwardRef as ReactComponent };